module.exports = __webpack_public_path__ + "static/media/banner-photo360@3x.1109cc2e.webp";